import { DataGrid } from '@mui/x-data-grid'
import { colors } from '../../../../utils'
import { useColumns } from './hooks'

const Observations = ({ newObservation, onOpenGallery }) => {
  const { column } = useColumns({ onOpenGallery })
  return (
    <DataGrid
      columns={column}
      rows={newObservation || []}
      autoHeight
      pagination
      pageSize={10}
      rowsPerPageOptions={[10]}
      disableColumnMenu
      disableSelectionOnClick
      sx={{
        width: "100%",
        backgroundColor: colors.white,
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
          outline: 'none',
        },
      }}
      initialState={{
        pagination: { paginationModel: { pageSize: 10 } },
      }}
    />
  )
}

export default Observations
